import { render } from "./Shelf.vue?vue&type=template&id=1ece9fab&scoped=true"
import script from "./Shelf.vue?vue&type=script&lang=js"
export * from "./Shelf.vue?vue&type=script&lang=js"

import "./Shelf.vue?vue&type=style&index=0&id=1ece9fab&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ece9fab"]])

export default __exports__